<template>
    <div class="find-places-map-control">
        <div class="input-wrapper">
            <img 
                src="@/assets/icons/googleMarker.svg" 
                alt="Marker" 
                class="input-icon"
            />
            <InputText 
                type="text" 
                v-model="findPlacesStore.searchInput" 
                class="w-100" 
                :placeholder="$t('Search on Google Maps')" 
                @keyup.enter="searchPlaces"
                :loading="findPlacesStore.loading"
            />
            <i class="pi pi-search search-icon" @click="searchPlaces"></i>
        </div>
    </div>
</template>

<script>
import { useFindPlacesStore } from '@/stores/findPlaces'

export default {
    name: 'FindPlaces',
    setup() {
        const findPlacesStore = useFindPlacesStore()

        return {
            findPlacesStore
        }
    },
    methods: {
        async searchPlaces() {
            await this.findPlacesStore.searchPlaces(this.findPlacesStore.searchInput)
        }
    }
}
</script>

<style scoped>
.find-places-map-control {
    margin-right: 10px;
    display: flex;
    flex-direction: row;
    gap: 6px;
    width: 350px;
}

.input-wrapper {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
}

.input-icon {
    position: absolute;
    left: 4px;
    z-index: 1;
    width: 24px;
    height: 24px;
    pointer-events: none;
}

.search-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    font-size: 16px;
    color: #666;
    cursor: pointer;
    pointer-events: auto;
}

.search-icon:hover {
    color: #000;
}

:deep(.p-inputtext) {
    background-color: #fff;
    text-align: left;
    color: #000;
    padding-left: 28px;
    padding-right: 32px;
    height: 40px;
    border-radius: 2px;
}

:deep(.p-inputtext::placeholder) {
    text-align: center;
    color: #666666;
}
</style>
